// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.balance-container-JXUGg {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  width: fit-content;
  cursor: pointer;
  border-radius: var(--radius-md);
  transition: background-color 0.2s ease;
  padding: 6px 4px 6px 12px;
}

.balance-container-JXUGg:hover {
  background-color: var(--color-neutral-100);
}

.balance-title-jNmUQ {
  color: var(--color-neutral-900);
  font-size: 15px;
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--tracking-wider);
}

.balance-value-ois0U {
  color: var(--money-color);
  font-size: 15px;
  font-weight: var(--font-weight-extrabold);
  margin-left: 4px;
}

.balance-icon-KavPh {
  --size: 22px;
  color: var(--color-neutral-600);
}
`, "",{"version":3,"sources":["webpack://./src/components/balance/balance.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  width: fit-content;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  transition: background-color 0.2s ease;\n  padding: 6px 4px 6px 12px;\n}\n\n.container:hover {\n  background-color: var(--color-neutral-100);\n}\n\n.title {\n  color: var(--color-neutral-900);\n  font-size: 15px;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: var(--tracking-wider);\n}\n\n.value {\n  color: var(--money-color);\n  font-size: 15px;\n  font-weight: var(--font-weight-extrabold);\n  margin-left: 4px;\n}\n\n.icon {\n  --size: 22px;\n  color: var(--color-neutral-600);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `balance-container-JXUGg`,
	"title": `balance-title-jNmUQ`,
	"value": `balance-value-ois0U`,
	"icon": `balance-icon-KavPh`
};
export default ___CSS_LOADER_EXPORT___;
